exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-device-header-note{color:white !important;opacity:.6;margin-left:.5rem}.edit-device-header-name{display:flex;justify-content:center;align-items:center}.edit-device-header-name-container{display:flex;align-items:center}.edit-device-header-note{color:white !important;opacity:.6;margin-left:.5rem}.edit-device-header{display:flex;align-items:center;justify-content:space-between}.tooltip-inner{white-space:pre-wrap}.ioprint-job-saved{color:#5cb85c}.ioprint-job-not-saved{color:#d9534f}.ioprint-job-id{font-family:monospace}\n", ""]);

// exports
